// extracted by mini-css-extract-plugin
export default {"cls1":"Rxt7GzQQjhxkLpe7nKGg","cls2":"KTyMY0Jq5B3ZtEvm1KqW Rxt7GzQQjhxkLpe7nKGg","isTabletDown":"uDBdEe14L2_qGK_BsTaE","isPhone":"_6K7IX2s0BRTHULg9AFyw"};